module.exports = __webpack_public_path__ + "img/three-red-fire.35831dd3.svg";